export default function (ModalService) {
    return function (notes) {
        return ModalService.showModal({
            controller: require('../../controllers/investigations/close/closeInvestigationCtrl'),
            template: require('../../controllers/investigations/close/closeInvestigation.html'),
            controllerAs: 'closeInvestigation',
            inputs: {
                notes
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/investigations/openCloseInvestigationModal.js